import axios from 'axios'
import store from 'src/store'
import { handleSnackbarOpen } from 'src/store/slice/RootSnackbarSlice'
import { handleLoadingMaskOpen, handleLoadingMaskClose } from 'src/store/slice/loadingMaskSlice'
import qs from 'qs'

export const baseURL = '/WEBPERSONAL'
export const ALIYUN_BASEURL = `https://api.joedar.com/WEBPERSONAL`

const axiosConfig = axios.create({ baseURL })

axiosConfig.interceptors.request.use(config => {
  store.dispatch(handleLoadingMaskOpen())
  if (config.data) config.data = qs.stringify(config.data)
  return config
}, err => {
  return Promise((resolve, reject) => { reject(err) })
})

axiosConfig.interceptors.response.use(resp => {
  store.dispatch(handleLoadingMaskClose())
  const { data } = resp
  if (typeof data === 'object' && !data.success && data.msg === 'logouted') {
    store.dispatch(handleSnackbarOpen({ message: 'System is logout' }))
  }
  return resp
}, err => {
  return Promise((resolve, reject) => { reject(err) })
})

export default axiosConfig
